import React, { useEffect, useRef, useState } from 'react';
import {debounce} from "../../../helpers/utils";
const styles = {
  transition: '.3s',
  overflow: 'hidden'
}
interface Props {
  children: any,
  isActive: boolean,
  extraSpacing?: number,
  className?: string,
  minHeight?: string,
  forceUpdate?: object
}

const DynamicToggle = ({children, isActive, extraSpacing = 0, className, minHeight = '0'}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [maxHeight, setMaxHeight] = useState(0);
  const PADDING_SPACING = 32;

  useEffect(() => {
    setMaxHeight(ref.current?.scrollHeight || 0)
    setTimeout(() => setMaxHeight((ref.current?.scrollHeight || 0) + extraSpacing), 2000)
  }, [isActive, extraSpacing])

  useEffect(() => {
    const handleWindowResize = debounce(() => {
      setMaxHeight((ref.current?.scrollHeight || 0) + extraSpacing)
    }, 250);

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };

  }, [extraSpacing])

  return (
    <div
      ref={ref}
      className={className}
      style={{...styles, maxHeight: isActive ? maxHeight + PADDING_SPACING : minHeight}}>
      {children}
    </div>
  )
}

export default React.memo(DynamicToggle, (prevProps, nextProps) => {
  if(prevProps.forceUpdate !== nextProps.forceUpdate) return false
  return prevProps.isActive === nextProps.isActive
})
